import { useI18n } from '../../lib/i18n'
import { useSiteToken } from '../../lib/token'
import type { JobView } from '../../upload/job'

/** How a job is named and where it stands, in the page's language. */
export function useJobLabels() {
  const { t } = useI18n()
  const { state } = useSiteToken()
  return {
    /** The folder, archive or file chosen, and how many more were chosen with it. */
    title: ({ roots }: Pick<JobView, 'roots'>) =>
      roots.length > 1 ? t('jobMore', { name: roots[0]!, count: String(roots.length - 1) }) : (roots[0] ?? ''),
    phase: ({ phase, error }: Pick<JobView, 'phase' | 'error'>) =>
      phase !== 'new' ? t(`phase_${phase}`) : error ? t('phase_failed') : state === 'set' ? t('phase_new') : t('phase_needsToken'),
  }
}
